module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero_arrow_down_bg-6ea5cf2b96ffdfaf9e683f48d4f5dc21.png";